import { Output, EventEmitter, OnInit } from '@angular/core';
import { WorkFieldIntegerChangeEvent } from '../../../events/work-field-integer-change-event';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';
import { FormControl, Validators } from '@angular/forms';

export class E5coreUiWorkFieldTypeIntegerBaseComponent extends E5coreUiWorkFieldTypeComponentBase implements OnInit {

  @Output() valueChange = new EventEmitter<WorkFieldIntegerChangeEvent>() ;

  formControl: FormControl ;

  ngOnInit() {
    const validators = [] ;
    if (this.field && this.field.isRequired) {
      validators.push(Validators.required) ;
    }
    this.formControl = new FormControl(this.property.value, validators);
    this.formControl.markAsTouched() ;
    const error = this.getError() ;

    this.updatePropertyValueOnChange(this.formControl) ;
    // this.workItem$.subscribe(
    //   wi => {
    //     let newProp = wi.properties.find(p => p.propertyId == this.propertyId) ;
    //     if(newProp && (newProp.value !== this.formControl.value) && (newProp.value != undefined))  {
    //       this.formControl.setValue(newProp.value) ;
    //     }
    //   }
    // )
  }

  protected getError(): string {
    let error = '' ;
    if (this.formControl.hasError('required')) {
      error = 'required' ;
    }
    return (error) ;
  }


  changeValue($event: number) {
    let error = '' ;
    if (this.formControl.hasError('required')) {
      error = 'required' ;
    }
    this.valueChange.emit({$event: $event, value: $event, error: error}) ;
  }

  blur($event) {
    this.changeValue(this.formControl.value) ;
  }
}
